import { categories } from '@/mocks/categories';
import { articleLinks } from '@/mocks/trustSignals';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-16">
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">Categories</h4>
            <div className="w-8 h-px bg-background-50/30 mb-4"></div>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">More Categories</h4>
            <div className="w-8 h-px bg-background-50/30 mb-4"></div>
            <div className="flex flex-col gap-2">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">SEO Guides 1-6</h4>
            <div className="w-8 h-px bg-background-50/30 mb-4"></div>
            <div className="flex flex-col gap-2">
              {articleLinks.slice(0, 6).map((article) => (
                <Link
                  key={article.path}
                  to={article.path}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                >
                  {article.title}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">SEO Guides 7-12</h4>
            <div className="w-8 h-px bg-background-50/30 mb-4"></div>
            <div className="flex flex-col gap-2">
              {articleLinks.slice(6).map((article) => (
                <Link
                  key={article.path}
                  to={article.path}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                >
                  {article.title}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between pt-8 border-t border-background-50/10">
          <div>
            <p className="font-heading text-4xl md:text-5xl font-bold tracking-tight">Mulebuy</p>
            <p className="text-sm text-background-50/40 mt-1">Spreadsheet System &copy; {new Date().getFullYear()}</p>
          </div>
          <div className="flex items-center gap-4 mt-6 sm:mt-0">
            <Link to="/" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer">
              <i className="ri-home-4-line text-background-50/70"></i>
            </Link>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer">
              <i className="ri-global-line text-background-50/70"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer">
              <i className="ri-shopping-bag-3-line text-background-50/70"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}